import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

import MobileStepper from '@material-ui/core/MobileStepper';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';

import { startEditWebsiteRoot } from 'store/actions/website';

const styles = theme => ({
  root: {

  },
  img: {
    alignSelf: 'center',
    height: '250px',
    width: '450px',
    overflow: 'hidden',
  },
});

class ContactSelect extends Component {
  constructor(props) {
    super(props);
    const { contactImages, initialFilename } = props;
    const initialIndex = contactImages.findIndex(item => item.filename === initialFilename);
    const activeStep = initialIndex >= 0 ? initialIndex : 0;

    this.state = {
      activeStep,
    };
  }

  handleNext = () => {
    const { contactImages, startEditWebsiteRoot } = this.props;

    this.setState(prevState => {
      const activeStep = prevState.activeStep + 1;
      const contactImage = contactImages[activeStep].filename;
      startEditWebsiteRoot({ contactImage });

      return ({
        activeStep,
      });
    });
  };

  handleBack = () => {
    const { contactImages, startEditWebsiteRoot } = this.props;

    this.setState(prevState => {
      const activeStep = prevState.activeStep - 1;
      const contactImage = contactImages[activeStep].filename;
      startEditWebsiteRoot({ contactImage });

      return ({
        activeStep,
      });
    });
  };

  render() {
    const {
      classes,
      theme,
      contactImages,
    } = this.props;
    const { activeStep } = this.state;
    const maxSteps = contactImages.length;
    const downloadURL = contactImages && contactImages[activeStep] ? contactImages[activeStep].downloadURL : "";
    const fileName = contactImages && contactImages[activeStep] ? contactImages[activeStep].fileName : "";

    return(
      <div>
        <img
          className={classes.img}
          src={downloadURL}
          alt={fileName}
        />
        <MobileStepper
          steps={maxSteps}
          position="static"
          activeStep={activeStep}
          className={classes.mobileStepper}
          nextButton={
            <Button size="small" onClick={this.handleNext} disabled={activeStep === maxSteps - 1}>
              Next
              {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </Button>
          }
          backButton={
            <Button size="small" onClick={this.handleBack} disabled={activeStep === 0}>
              {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
              Back
            </Button>
          }
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  contactImages: state.contactImagesState.sort((a, b) => {
    if (a.filename < b.fileName) {
      return -1;
    } else if (a.filename > b.filename) {
      return 1;
    } else {
      return 0;
    }
  }),
});

const mapDispatchToProps = {
  startEditWebsiteRoot,
};

export default compose(
  withStyles(styles, { withTheme: true }),
  connect(mapStateToProps, mapDispatchToProps),
)(ContactSelect);



// WEBPACK FOOTER //
// ./src/components/admin/Website/Main/ContactSelect.jsx